
import { 
    GET_ANALYSIS,
    GET_ANALYSIS_SUCCESS,
    GET_ANALYSIS_FAIL, 
    GET_ANALYSIS_RESET,
} from "../actions/getAnalysisAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getAnalysisReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ANALYSIS:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_ANALYSIS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_ANALYSIS_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_ANALYSIS_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getAnalysisReducer;
